import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { end: String }
  static targets = ["display", "pending", "ready"]
  static tickInterval = 250
  static readyDelay = 400

  connect() {
    this.completed = false
    this.endTime = new Date(this.endValue).getTime()
    this.tick()
    this.timer = setInterval(() => this.tick(), this.constructor.tickInterval)
    this.handleVisibilityChange = () => this.onVisibilityChange()
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
    this.onVisibilityChange()
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
  }

  onVisibilityChange() {
    if (document.visibilityState === "visible") {
      this.tick()
    }
  }

  complete() {
    if (this.completed) return

    this.completed = true
    if (this.timer) clearInterval(this.timer)
    this.displayTarget.textContent = "0s"

    if (this.hasReadyTarget) {
      setTimeout(() => {
        if (!this.isConnected) return
        if (this.hasPendingTarget) this.pendingTarget.classList.add("hidden")
        this.readyTarget.classList.remove("hidden")
      }, this.constructor.readyDelay)
    } else if (this.hasPendingTarget) {
      this.pendingTarget.classList.add("hidden")
    }

    this.dispatch("complete")
  }

  tick() {
    const remainingMs = this.endTime - Date.now()

    if (remainingMs <= 0) {
      this.complete()
      return
    }

    const remaining = Math.ceil(remainingMs / 1000)
    const hours = Math.floor(remaining / 3600)
    const minutes = Math.floor((remaining % 3600) / 60)
    const seconds = remaining % 60

    let display = ""
    if (hours > 0) display += `${hours}h `
    if (minutes > 0 || hours > 0) display += `${minutes}m `
    display += `${seconds}s`

    this.displayTarget.textContent = display
  }
}
